var _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNormalSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 0,
    fill: "currentColor",
    fillOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,21.040974617004395,-2.2940263748168945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.917500495910645,9.99847412109375L12.917500495910645,15.83180412109375Q12.917500495910645,16.45680412109375,12.292500495910645,16.45680412109375Q11.667500495910645,16.45680412109375,11.667500495910645,15.83180412109375L11.667500495910645,9.99847412109375Q11.667500495910645,9.37347412109375,12.292500495910645,9.37347412109375Q12.917500495910645,9.37347412109375,12.917500495910645,9.99847412109375Z",
    fill: "#FFCC00",
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,20.000783920288086,-15.000783920288086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.999333920288088,4.08333L31.124383920288086,16.3333L26.607673920288086,16.3333L26.041003920288084,15.2L25.532673920288087,14.1667C25.431373920288085,13.9625,25.223113920288085,13.8333,24.995173920288085,13.8333C24.767223920288085,13.8333,24.558973920288086,13.9625,24.457673920288087,14.1667L23.949333920288087,15.1833L23.399333920288086,16.3167L18.874333920288088,16.3167L24.999333920288088,4.08333ZM24.999333920288088,2.5C24.685543920288087,2.500951588,24.398883920288085,2.6781,24.257673920288084,2.958334L17.591003020288085,16.2917C17.312215920288086,16.844900000000003,17.713152920288085,17.4981,18.332669920288087,17.5L23.566003920288086,17.5C23.918743920288087,17.5148,24.246443920288087,17.318199999999997,24.399333920288086,17L24.999333920288088,15.7167L25.641003920288085,17.0083C25.797983920288086,17.3218,26.124063920288087,17.514200000000002,26.474333920288085,17.5L31.665983920288085,17.5C32.279683920288086,17.4951,32.67768392028809,16.851100000000002,32.407683920288086,16.3L25.741003920288087,2.966666C25.602123920288086,2.683196,25.314993920288085,2.50252992,24.999333920288088,2.5Z",
    fill: "currentColor",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNormalSend);
export default __webpack_public_path__ + "static/media/icon-normalSend.cf49d6d769926fe62c8ef6c4df7ecee6.svg";
export { ForwardRef as ReactComponent };